export const AGENTS_EXPORT_TYPE_PREPAY = 1
export const AGENTS_EXPORT_TYPE_DETAILLED = 2
export const AGENTS_EXPORT_TYPE_STAFF = 3

export const AGENTS_EXPORT_TYPES = [
  { value: AGENTS_EXPORT_TYPE_PREPAY, label: 'Prépaie' },
  { value: AGENTS_EXPORT_TYPE_STAFF, label: 'Registre du Personnel' },
  { value: AGENTS_EXPORT_TYPE_DETAILLED, label: 'Export détaillé' }
]
export const AGENTS_EXPORT_TYPES_KEYED = _.keyBy(AGENTS_EXPORT_TYPES, 'value')

export const AGENT_EXPORT_HOURS_KEY_HOURS = 'hours'
export const AGENT_EXPORT_HOURS_KEY_UNAVAILABILITIES = 'unavailabilities'

export const AGENT_EXPORT_HOURS_DATA = [
  { label: `Heures (total)`, key: AGENT_EXPORT_HOURS_KEY_HOURS },
  { label: `Heures de jour`, key: 'day' },
  { label: `Heures de jour férié`, key: 'holiday' },
  { label: `Heures de nuit`, key: 'night' },
  { label: `Heures de nuit férié`, key: 'holidaynight' },
  { label: `Heures samedi de jour`, key: 'saturday', saturday: true },
  { label: `Heures samedi de jour férié`, key: 'saturdayholiday', saturday: true },
  { label: `Heures samedi de nuit`, key: 'saturdaynight', saturday: true },
  { label: `Heures samedi de nuit férié`, key: 'saturdayholidaynight', saturday: true },
  { label: `Heures dimanche de jour`, key: 'sunday' },
  { label: `Heures dimanche de jour férié`, key: 'sundayholiday' },
  { label: `Heures dimanche de nuit`, key: 'sundaynight' },
  { label: `Heures dimanche de nuit férié`, key: 'sundayholidaynight' },
  { label: `Heures d'indisponibilité`, key: AGENT_EXPORT_HOURS_KEY_UNAVAILABILITIES }
]
